export default "/static/build/main.webp";